
export interface LocationOption {
  name: string; // Hebrew name
  id: number;   // Chabad.org locationId
  lat: number;  // Latitude for fallback calculations
  lng: number;  // Longitude for fallback calculations
}

export const ISRAEL_CITIES: LocationOption[] = [
  { name: "ירושלים", id: 1129, lat: 31.7767, lng: 35.2345 },
  { name: "תל אביב", id: 1031, lat: 32.0853, lng: 34.7818 },
  { name: "חיפה", id: 1049, lat: 32.8191, lng: 34.9983 },
  { name: "באר שבע", id: 1033, lat: 31.2518, lng: 34.7915 },
  { name: "נתניה", id: 1067, lat: 32.3215, lng: 34.8532 },
  { name: "אשדוד", id: 1032, lat: 31.8044, lng: 34.6553 },
  { name: "פתח תקווה", id: 1068, lat: 32.0878, lng: 34.8878 },
  { name: "רמת גן", id: 1073, lat: 32.0704, lng: 34.8243 },
  { name: "אשקלון", id: 1039, lat: 31.6688, lng: 34.5742 },
  { name: "חולון", id: 1050, lat: 32.0117, lng: 34.7731 },
  { name: "בת ים", id: 1035, lat: 32.0167, lng: 34.7500 },
  { name: "רחובות", id: 1072, lat: 31.8969, lng: 34.8186 },
  { name: "כפר סבא", id: 1056, lat: 32.1742, lng: 34.9063 },
  { name: "הרצליה", id: 1047, lat: 32.1624, lng: 34.8443 },
  { name: "חדרה", id: 1031, lat: 32.4347, lng: 34.9102 },
  { name: "מודיעין", id: 1064, lat: 31.8969, lng: 35.0095 },
  { name: "לוד", id: 1060, lat: 31.9496, lng: 34.8956 },
  { name: "רמלה", id: 1074, lat: 31.9295, lng: 34.8670 },
  { name: "נהריה", id: 1066, lat: 33.0072, lng: 35.0938 },
  { name: "עכו", id: 1030, lat: 32.9315, lng: 35.0818 },
  { name: "טבריה", id: 1077, lat: 32.7940, lng: 35.5355 },
  { name: "צפת", id: 1078, lat: 32.9716, lng: 35.4951 },
  { name: "אילת", id: 1029, lat: 29.5569, lng: 34.9516 },
  { name: "דימונה", id: 1043, lat: 31.0689, lng: 35.0322 },
  { name: "קריית גת", id: 1058, lat: 31.6103, lng: 34.7642 },
  { name: "קריית שמונה", id: 1059, lat: 33.2074, lng: 35.5691 },
  { name: "בית שמש", id: 1036, lat: 31.7531, lng: 34.9896 },
  { name: "גבעתיים", id: 1044, lat: 32.0693, lng: 34.8088 },
  { name: "רעננה", id: 1075, lat: 32.1847, lng: 34.8707 },
];

export const DEFAULT_LOCATION = ISRAEL_CITIES.find(city => city.name === "ירושלים")!;

export const findCityByName = (name: string): LocationOption | undefined => {
  return ISRAEL_CITIES.find(city => 
    city.name.includes(name) || name.includes(city.name)
  );
};

export const findCityById = (id: number): LocationOption | undefined => {
  return ISRAEL_CITIES.find(city => city.id === id);
};
